import { Indicator } from 'models/indicator.interface';
import { IndicatorDiplay } from 'models/response/indicatorDisplay.interface';

interface Properties {
  data: IndicatorDiplay;
  driverId: number;
}

const transformIndicatorDisplay = ({ data, driverId }: Properties) => {
  if (!data) return {};

  return data?.index.reduce(
    (accumulator: Record<string, Indicator[]>, next: string, index: number) => {
      const innerData = data.columns.map((columnName: string, columnNameIndex: number) => ({
        name: columnName,
        value: data.data[index][columnNameIndex],
        dimensionItem: next,
        id: next + columnName + driverId,
        index,
      }));
      accumulator[index] = innerData;

      return accumulator;
    },
    {},
  );
};

export default transformIndicatorDisplay;
